/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'uikit/loaders';
import { Typo } from 'uikit/content';

// import { ModificationAutoSaveForm } from 'core/forms'; uncomment out when the component is finished

import VideosPermissionsAutoSave from './videosPermissionsAutoSave';

import styles from '../styles/videosAdminPermissionsForm.module.scss';

const VideosAdminPermissionsForm = ({
  schema,
  model,
  onUpdate,
  shouldShowLoading,
  title,
  body,
  onAutoSave,
}) => (
  <section className={styles.element}>
    {(shouldShowLoading) && (
    <Loading />
    )}
    {(!shouldShowLoading) && (
    <div className={styles.formWrap}>
      <div className={styles.textWrap}>
        <Typo variant="d01">{title}</Typo>
        <Typo variant="b01" element="p">{body}</Typo>
      </div>
      {/* Replace below with the autosave component when it's ready */}
      <VideosPermissionsAutoSave
        schema={schema}
        model={model}
        onAutoSave={onAutoSave}
        onFormUpdate={onUpdate}
      />
    </div>
    )}
  </section>
);

VideosAdminPermissionsForm.defaultProps = {
  title: '',
  body: '',
  shouldShowLoading: false,
  schema: {},
  model: {},
  onUpdate: () => {},
};

VideosAdminPermissionsForm.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  shouldShowLoading: PropTypes.bool,
  schema: PropTypes.shape({}),
  model: PropTypes.shape({}),
  onUpdate: PropTypes.func,
};

export default React.memo(VideosAdminPermissionsForm);
